import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { createElement } from 'react';

import { ContractForm } from '~/modules/contract/form';

import { createProtectedRoute } from '~/utils/routeProtection';

import { routeParams } from '../../-routeParams';
import { zodContractItemsTableSearchSchema } from '../../-searchParams';

/**
 * Owns the contract form for the edit page and its line item pages, so the
 * form state survives navigating between them. The child routes only put the
 * line item id into the URL.
 */
export const Route = createFileRoute(
  '/(main)/demand/contracts/$contractId/edit',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/contracts/$contractId/edit',
    ...routeParams,
  }),
  // Wrapper function to avoid circular dependency init errors.
  component: () => createElement(ContractForm),
  search: {
    middlewares: [
      stripSearchParams(zodContractItemsTableSearchSchema.parse({})),
    ],
  },
  validateSearch: zodContractItemsTableSearchSchema,
});
